export default __webpack_public_path__ + "static/media/about-page.f79a1d79.png";